function fnProcess(i, oSection) {
  gsap.context(() => {
    const lastEl = oSection.querySelector(".item:last-child");
    const startOffset = oSection.querySelector(".items").offsetLeft;
    const endOffset =
      window.innerWidth / 2 -
      lastEl.offsetWidth / 2 -
      startOffset -
      lastEl.offsetLeft;

    console.log(
      endOffset,
      window.innerWidth / 2,
      startOffset,
      lastEl.offsetLeft,
      lastEl.offsetWidth
    );

    const endPin = `+=${
      oSection.querySelectorAll(".item").length * (window.innerHeight * 0.3)
    }`;

    console.log(endPin);

    gsap.to(".items", {
      x: endOffset,
      ease: "none",
      scrollTrigger: {
        trigger: ".container",
        pin: true,
        scrub: 0.5,
        start: "center center",
        end: endPin,
        invalidateOnRefresh: true,
      },
    });

    gsap.to(".progress-line", {
      width: lastEl.offsetLeft,
      ease: "none",
      scrollTrigger: {
        trigger: ".container",
        scrub: 1,
        start: "center center",
        end: "+=1000px",
        invalidateOnRefresh: true,
      },
    });

    gsap.to(".item", {
      opacity: 1,
      ease: "none",
      stagger: 0.6,
      scrollTrigger: {
        trigger: oSection,
        scrub: 0.5,
        start: "top bottom",
        end: "bottom bottom",
        invalidateOnRefresh: true,
      },
    });
  }, oSection);
}
